<div
	#Checkbox
	class="filter-checkbox-container"
	[class.is-selected]="isChecked"
	[attr.data-test]="dataTest">
	<div
		class="filter-checkbox"
		[attr.data-test]="'checkboxIsChecked:' + isChecked"
		[style.width]="size"
		[style.height]="size">
		<div *ngIf="isChecked">
		</div>
	</div>

	<span class="filter-checkbox-label">
		<span data-test="checkboxLabel">
			{{ label }}
		</span>

		<span
			*ngIf="isAmountShown && (amount || amount === 0)"
			data-test="checkboxAmount">
			{{ amount }}
		</span>
	</span>
</div>
